import { useCallback } from 'react';

import { postVacancyApplication } from '../../../services';
import { PostVacancyApplicationRequestInterface } from '../../../types/vacancies.types';
import { ApiServiceType, useApiService } from '../useApiService';

import { getErrorMessage } from './usePostVacancyApplication.strings';
import { PostVacancyApplicationHookType } from './usePostVacancyApplication.types';

export const usePostVacancyApplication: PostVacancyApplicationHookType = ({
  applicationData,
  immediateExecute,
} = {}) => {
  const service: ApiServiceType<PostVacancyApplicationRequestInterface, object> = useCallback(
    async ({ requestData, abortController } = {}) => {
      if (!requestData) {
        throw new Error('Request data must be defined');
      }
      const { file, ...submitData } = requestData;
      return postVacancyApplication(submitData, file, abortController);
    },
    []
  );

  const serviceResult = useApiService<PostVacancyApplicationRequestInterface, object>({
    service,
    initialServiceRequestData: applicationData,
    immediateExecute,
  });

  return {
    ...serviceResult,
    postVacancyApplication: serviceResult.executeCall,
    vacancyApplicationError: getErrorMessage(serviceResult.error),
  };
};
